import { Box, Grid, PageWrapper, Typography } from '@oresundsbron/bridge-ui';
import { cx } from 'class-variance-authority';
import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import { useTranslation } from 'next-i18next';
import { useBridgeStatus } from '~/hooks/useBridgeStatus';
import { useLocale } from '~/stores/locale';
import { bgStatusBorderColors } from './utils';
import { InfoItem } from './InfoItem';

export const BridgeInfo = () => {
  const { t } = useTranslation(['bridgeStatus', 'common'], {
    nsMode: 'fallback',
  });
  const { data, isDetailsLoading } = useBridgeStatus();

  const { dateLocale } = useLocale();
  const borderColor = bgStatusBorderColors[data.status] || 'bg-neutral-400';

  const { info } = data;

  return (
    <Box className="col-span-full">
      {isDetailsLoading ? (
        <PageWrapper
          as="div"
          className={cx(
            borderColor,
            'pb-6 pt-8 even:border-t-2 sm:pb-8 sm:pt-10 md:pb-10 md:pt-12'
          )}
        >
          <Grid className="col-start-2">
            <Box className="col-span-2 row-start-1 h-[28px] animate-pulse bg-neutral-400" />
            <Box
              className="col-span-4 row-start-2 flex flex-col gap-2"
              as="div"
            >
              <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
              <Box className="h-[16px] animate-pulse bg-neutral-400" />
            </Box>
            <Box className="col-span-full row-start-3 flex max-w-[65ch] flex-col gap-2 pb-2">
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
            </Box>
            <Box className="col-span-2 row-start-4 flex flex-col gap-2 pb-2 sm:col-span-3">
              <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
            </Box>
            <Box className="col-span-2 row-start-4 flex flex-col gap-2 pb-2 sm:col-span-3">
              <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
            </Box>
            <Box className="col-span-2 row-start-5 flex flex-col  gap-2 pb-2 sm:col-span-3 md:row-start-4">
              <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
            </Box>
            <Box className="col-span-2 row-start-5 flex flex-col gap-2 pb-2 sm:col-span-3 md:row-start-4">
              <Box className="h-[16px] w-1/2 animate-pulse bg-neutral-400" />
              <Box className="h-[16px] w-full animate-pulse bg-neutral-400" />
            </Box>
          </Grid>
        </PageWrapper>
      ) : info && info.length > 0 ? (
        info.map((infoItem, idx) => {
          const {
            restriction,
            comment,
            event,
            location,
            direction,
            time,
            endtime,
          } = infoItem;
          return (
            <PageWrapper
              as="div"
              className={cx(
                borderColor,
                'pb-6 pt-8 even:border-t-2 sm:pb-8 sm:pt-10 md:pb-10 md:pt-12'
              )}
              key={idx}
            >
              <Grid className="col-start-2">
                <Typography
                  as="h3"
                  intent="title"
                  size="lg"
                  className="col-span-full"
                >
                  {restriction}
                </Typography>
                {event ? (
                  <Typography className="col-span-full">
                    <Typography as="span" intent="label" size="lg">
                      {t('bridgeStatus.statusDetails.labels.event')}
                    </Typography>
                    <Typography as="span" intent="body" weight="medium">
                      {event}
                    </Typography>
                  </Typography>
                ) : null}
                {comment ? (
                  <Typography className="col-span-full max-w-[65ch] pb-2">
                    {comment}
                  </Typography>
                ) : null}

                <InfoItem
                  titleKey={'bridgeStatus.statusDetails.labels.location'}
                  value={location}
                />
                <InfoItem
                  titleKey={'bridgeStatus.statusDetails.labels.direction'}
                  value={direction || '-'}
                />
                <InfoItem
                  titleKey={'bridgeStatus.statusDetails.labels.time'}
                  value={
                    time
                      ? formatInTimeZone(
                          time,
                          'Europe/Stockholm',
                          'yyyy-MM-dd HH:mm',
                          {
                            locale: dateLocale,
                          }
                        )
                      : '-'
                  }
                />
                <InfoItem
                  titleKey={'bridgeStatus.statusDetails.labels.endtime'}
                  value={
                    endtime
                      ? formatInTimeZone(
                          endtime,
                          'Europe/Stockholm',
                          'yyyy-MM-dd HH:mm',
                          {
                            locale: dateLocale,
                          }
                        )
                      : '-'
                  }
                />
              </Grid>
            </PageWrapper>
          );
        })
      ) : null}
    </Box>
  );
};
